var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup67(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(-316 -63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M3.307,15.822a.946.946,0,1,1,0,1.891H.946a.944.944,0,1,1,0-1.888H3.307v0ZM5.58,9.22a.943.943,0,0,1-.94,1.635L2.6,9.676a.943.943,0,1,1,.94-1.635L5.58,9.22Zm5.275-4.583a.944.944,0,0,1-1.635.946L8.041,3.54a.944.944,0,1,1,1.635-.946l1.179,2.042Zm19.508,6.218a.943.943,0,0,1-.94-1.635l2.042-1.179a.943.943,0,1,1,.94,1.635l-2.042,1.179Zm-4.58-5.272a.944.944,0,0,1-1.635-.946l1.179-2.042a.944.944,0,1,1,1.635.946L25.783,5.583Zm-6.6-2.276a.946.946,0,1,1-1.891,0V.946a.946.946,0,1,1,1.891,0V3.307ZM31.7,17.716a.946.946,0,0,1,0-1.891h2.358a.946.946,0,1,1,0,1.891Z",
    transform: "translate(316 63)",
    fill: "#614385",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M38.216,24.77h.96a8.6,8.6,0,0,1,8.579,8.579v8.7H29.64v-8.7a8.6,8.6,0,0,1,8.576-8.576Z",
    transform: "translate(294.86 45.285)",
    fill: "none",
    stroke: "#3c1a5b",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M39.715,47.376H37.969V45.1c0-.635,0-.7,0-.778-.026-2.427-.048-4.495,1.985-6.611a7.034,7.034,0,0,1,2-1.444,23.122,23.122,0,0,0-2.239,11.106Z",
    transform: "translate(288.852 37.061)",
    fill: "#516395",
    fillRule: "evenodd",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    transform: "translate(321 87)",
    fill: "none",
    stroke: "#3c1a5b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 6,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 5,
    rx: 0.5,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup67);
export default __webpack_public_path__ + "static/media/Group 67.1cf121a0e16ec437cd9594df4564190b.svg";
export { ForwardRef as ReactComponent };